import appConstants from '../../../../../../../appConstants';
import { withAppConfig } from '@appConfigContext';
import { isLiftgateReasonEnabled } from '../../../DriverPopUp/common/liftgateUtils';
import StopDetailsTitle from '../../../DriverPopUp/common/StopDetailsTitle';
import Label from '../../common/Label';
import DeliveryStatusBadge from '../../DeliveryStatusBadge';
import StopDetails from '../../StopDetails';
import ReturnDetails from '../../ReturnDetails';
import OSNDDetails from '../../OSNDDetails';
import ExceptionQADetails from '../../ExceptionQADetails';
import DriverDetails from '../../DriverDetails';
import ShipperDetails from '../../ShipperDetails';
import ShipmentDetails from '../../ShipmentDetails';
import ShipmentInfo from '../../ShipmentInfo';
import Accessorial from '../../Accessorial';
import ExcessiveLength from '../../ExcessiveLength';
import ShrinkWrap from '../../ShrinkWrap';
import PhysicalPieces from '../../PhysicalPieces';
import ReceiverDetails from '../../ReceiverDetails';
import HazmatDetails from '../../HazmatDetails';
import { Divider } from '@material-ui/core';

const ProDetails = ({
  classes,
  proDetails,
  deliveryStatusList,
  freightBillDetailsApi,
  freightBillDetailsQueryParams,
  DispatchStore,
  enableReturnExceptionReasonLabels,
  configJSON
}) => {
  const enableLiftgateReason = isLiftgateReasonEnabled(configJSON);
  const { proData, stopData, driverData } = proDetails ?? {};
  const exceptionQaList =
    proData?.deliveryCode === appConstants.DELIVERY_CODE.RTN
      ? proData?.returnDetail?.exceptionQa ?? []
      : proData?.exceptionDetail?.[0]?.exceptionQa ?? [];
  return (
    <>
      <StopDetailsTitle
        stopData={stopData}
        isUnattendedDelivery={proData.isUnattendedDelivery}
        enableCustomerLink
        showCustomerCode
      />
      <div className={classes.delStatusContainer}>
        <div className={classes.deliveryStatusLabel}>
          <Label labelText="Delivery Status" />
        </div>
        <DeliveryStatusBadge
          isCompleted={stopData.isStopCompleted}
          deliveryStatusList={deliveryStatusList}
          proData={proData}
          DispatchStore={DispatchStore}
          enableReturnExceptionReasonLabels={enableReturnExceptionReasonLabels}
        />
      </div>
      {stopData.isStopCompleted && <StopDetails stopData={stopData} />}
      {proData.deliveryCode === appConstants.DELIVERY_CODE.RTN && (
        <>
          <Divider className={classes.divider} />
          <ReturnDetails returnDetail={proData.returnDetail} />
        </>
      )}
      {proData?.deliveryCode === appConstants.DELIVERY_CODE.DE &&
        DispatchStore.staticClientData &&
        proData?.exceptionDetail && (
          <>
            <Divider className={classes.divider} />
            <OSNDDetails
              exceptionDetail={proData.exceptionDetail}
              exceptionList={DispatchStore.exceptions}
            />
          </>
        )}
      {(proData?.deliveryCode === appConstants.DELIVERY_CODE.DE ||
        proData?.deliveryCode === appConstants.DELIVERY_CODE.RTN) &&
        exceptionQaList.length > 0 && (
          <>
            <Divider className={classes.divider} />
            <ExceptionQADetails qaList={exceptionQaList} />
          </>
        )}
      <Divider className={classes.divider} />
      <DriverDetails driverData={driverData} />
      <Divider className={classes.divider} />
      <ShipmentDetails
        proData={proData}
        isCompleted={stopData.isStopCompleted}
        packageCode={proData.exceptionDetail?.packageType || proData.returnDetail?.packageType}
      />
      <Divider className={classes.divider} />
      {proData.hazmatInfo?.length > 0 && (
        <>
          <HazmatDetails hazmatInfo={proData.hazmatInfo} />
          <Divider className={classes.divider} />
        </>
      )}
      <ShipperDetails proData={proData} />
      <Divider className={classes.divider} />
      <ShipmentInfo
        shipmentId={proData.shipmentId}
        freightBillDetailsApi={freightBillDetailsApi}
        freightBillDetailsQueryParams={freightBillDetailsQueryParams}
      />
      {stopData.isStopCompleted && DispatchStore.staticClientData && (
        <>
          {proData.accessorials?.length > 0 && DispatchStore.staticClientData && (
            <Accessorial
              accessorialList={DispatchStore.deliveryAccessorials}
              selectedAccessorials={proData.accessorials}
              limitedAccessList={DispatchStore.limitedAccessList}
              selectedLimitedAccessCode={proData.limitedAccessCode}
              liftgateReasonList={enableLiftgateReason ? DispatchStore.liftgateReasonList : []}
              selectedLiftgateReasonCode={
                enableLiftgateReason ? proData.liftgateReasonCode : undefined
              }
              sortAndSegregatePieces={proData.sortAndSegregatePieces}
            />
          )}
          <Divider className={classes.divider} />
          <ExcessiveLength
            excessiveLength={proData.excessiveLength}
            excessiveLengthFeet={proData.excessiveLengthValue}
            excessiveLengthInches={proData.excessiveLengthInches}
          />
          <Divider className={classes.divider} />
          <ShrinkWrap
            isShrinkWrap={proData.isShrinkWrap}
            palletCount={proData.palletCount}
            tallyCount={proData.tallyCount}
          />
          <Divider className={classes.divider} />
          <PhysicalPieces
            isPhysicalPiecesChanged={proData.isPhysicalPiecesChanged}
            physicalPiecesHandled={proData.physicalPiecesHandled}
          />
          <Divider className={classes.divider} />
          <ReceiverDetails proData={proData} />
        </>
      )}
    </>
  );
};

export default withAppConfig(ProDetails);
